//
//
//
//
//
//
//
//
//
//
//
//

import { focus } from "../../../utilities/directives";
import { checkIfUrlIsExternal } from "~/helpers/validation-utils";
export default {
  name: "MoominLink",
  directives: { focus },
  props: {
    link: {
      type: [String, Object],
    },
  },
  computed: {
    isExternal() {
      return checkIfUrlIsExternal(this.link);
    },
    fixLinkProtocol() {
      let fixedLink = this.link;
      if(!this.isExternal) return fixedLink;
      if(!fixedLink[0] === '#') return fixedLink;

      // Regular expression to check if the link starts with http:// or https://
      const httpRegex = /^(http|https):\/\//i;

      // If the link doesn't start with http:// or https://, add the protocol
      if (!httpRegex.test(fixedLink)) {
        fixedLink = `https://${fixedLink}`;
      }

      return fixedLink;
    },
    getLinkTarget() {
      return this.isExternal ? "_blank" : "_self"
    },
    isNativeLinkTag() {
      return this.isExternal || !this.$router;
    },
    urlTag() {
      if(!this.fixLinkProtocol) return {};
      return this.isNativeLinkTag
        ? { href: this.fixLinkProtocol }
        : { to: this.fixLinkProtocol || "" };
    },
    linkComponentTag() {
      const routerLink = this.$nuxt ? "nuxt-link" : "router-link";
      return !this.link ? 'span' : this.isNativeLinkTag ? "a" : routerLink;
    },
  },
};
